import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RappiderFieldFormattingToolbarComponent } from './field-formatting-toolbar.component';
import { RappiderColorPickerModule } from '../color-picker/color-picker.module';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { RappiderIconModule } from '../icon/icon.module';

@NgModule({
  declarations: [
    RappiderFieldFormattingToolbarComponent
  ],
  exports: [
    RappiderFieldFormattingToolbarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RappiderColorPickerModule,
    NzDropDownModule,
    NzMenuModule,
    NzToolTipModule,
    RappiderIconModule
  ]
})
export class RappiderFieldFormattingToolbarModule { }
